<template>
    <div>
      <vs-prompt
      @cancel="canceld"
      @accept="accepted"
      @close="closed"
      :active.sync="dlgActive"
      :title="popupTitle"
      :accept-text="$t('COM.SAVE')"
      :cancel-text="$t('COM.CANCEL')"
      id="promptAddNewsletter"
      :is-valid="formValid">
       <div>
          <div v-if="wasSent === false">
            <p>{{$t('NEWSLETTER.ADD_NEWSLETTER.HEADER.TEXT')}}</p>
            <div class="default-input clearfix align-items-center mb-3">
              <vs-input :disabled="wasSent" :label="$t('NEWSLETTER.ADD_NEWSLETTER.NAME')"  class="mr-3 inputx float-left" :placeholder="$t('NEWSLETTER.PLACEHOLDER.ADD_NEWSLETTER.NAME')"  v-model="data.name" :danger="name_fail" val-icon-danger="clear"/>
              <vs-input :disabled="wasSent" :label="$t('NEWSLETTER.ADD_NEWSLETTER.SUBJECT')"  class="mr-3 inputx float-left"  :placeholder="$t('NEWSLETTER.PLACEHOLDER.ADD_NEWSLETTER.SUBJECT')"  v-model="data.subject" :danger="subject_fail" val-icon-danger="clear"/>
            </div>  
            <div class="default-input clearfix align-items-center mb-3">
                <vs-select :disabled="wasSent" :label="$t('NEWSLETTER.ADD_NEWSLETTER.TEMP_FK')" v-model="data.template_fk" class="float-left inputx mr-3">
                  <vs-select-item :key="index" :value="item.value" :text="item.text" v-for="(item,index) in templates" />
                </vs-select>
                <vs-select :disabled="wasSent" :label="$t('NEWSLETTER.ADD_NEWSLETTER.REC_FK')" v-model="data.rec_list_fk" class="float-left inputx mr-3">
                  <vs-select-item :key="index" :value="item.value" :text="item.text" v-for="(item,index) in recLists" />
                </vs-select>
            </div>       
            <div  class="default-input clearfix align-items-center mb-3">
              <div  class="float-left mr-2">
                <VueTrix  v-model="data.text" :placeholder="$t('NEWSLETTER.PLACEHOLDER.TEXT')" />
              </div>
            </div>   
          </div>
          <div v-if="wasSent === true">
            <div class="default-input clearfix align-items-center mb-3">
              <div  class="mr-3 inputx float-left">{{ $t('NEWSLETTER.ADD_NEWSLETTER.NAME') }}: <strong>{{data.name}}</strong></div>
              <div  class="mr-3 inputx float-left">{{ $t('NEWSLETTER.ADD_NEWSLETTER.SUBJECT') }}: <strong>{{data.subject}}</strong></div>
            </div>
            <div class="default-input clearfix align-items-center mb-3">
              <div  class="mr-3 inputx float-left">{{ $t('NEWSLETTER.ADD_NEWSLETTER.TEMP_FK') }}: <strong>{{getTemplateNameById(data.template_fk)}}</strong></div>
              <div  class="mr-3 inputx float-left">{{ $t('NEWSLETTER.ADD_NEWSLETTER.REC_FK') }}: <strong>{{getRecListNameById(data.rec_list_fk)}}</strong></div>
            </div>
            <div class="default-input clearfix align-items-center mb-3">
              <div v-html="data.text"></div>
            </div>
          </div>
          <div v-if="wasSent === true" id="newsletter_table" class="vs-con-loading__container" >
                <vs-table
                  search
                  :data="statusMember"
                  :noDataText="$t('NEWSLETTER.NO_DATA')"
                  stripe
                  max-items="10" 
                  pagination
                  hoverFlat>

                  <template slot="header">
                      {{$t('NEWSLETTER.STATUS.TABLE.HEADER')}}{{ ' (' + data.nr_rec + ')' }}
                  </template>
                  <template slot="thead">                               
                    <vs-th >
                      {{$t('NEWSLETTER.STATUS.TABLE.COL1')}}
                    </vs-th>
                    <vs-th >
                      {{$t('NEWSLETTER.STATUS.TABLE.COL2')}}
                    </vs-th>                                                                                                                                                                                                                                                 
                  </template>

                  <template slot-scope="{data}">
                    <vs-tr :data="tr"  :key="indextr" v-for="(tr, indextr) in data" >   
                      <vs-td :data="tr.name">
                        {{tr.name}}
                      </vs-td>                  
                      <vs-td :data="tr.status">
                        {{tr.status}}
                      </vs-td>                                                                                                                                                                                        
                    </vs-tr>
                  </template>
                </vs-table>
              </div>  
       </div>
     </vs-prompt>
    </div>
</template>
<script>

import helperMethods from '../../../helper/staticFuncHelper';
import codeHelper from '../../../helper/staticCodeHelper';
import enumHelper from '../../../helper/enumHelper';
import VueTrix from "vue-trix";

export default {
  name: "AddNewsletterDlg",
  props:[],
  components:{
        VueTrix
  },
  data: function (){
     return {
      dlgActive:false,
      popupTitle:this.$t('NEWSLETTER.ADD_NEWSLETTER.TITLE'),
      name_fail:false,
      name_ok:false,
      subject_fail:false,
      subject_ok:false, 
      data:this.GetEmptyData()
     }
  }, 
  mounted () {
    this.ClearForm();
  },
  methods:{
      ...helperMethods,
      ...codeHelper,
      ...enumHelper,
      ShowDlg(){
        this.ClearForm();
        this.dlgActive=true;
        this.popupTitle = this.$t('NEWSLETTER.ADD_NEWSLETTER.TITLE');
        
      },
      closed(){
        this.ClearForm();
      },
      InitDlgData(data){
        
        if(this.IsNotNull(data))
        {
          this.ClearForm();
          this.popupTitle = this.$t('NEWSLETTER.ADD_NEWSLETTER.TITLE.EDIT');
          
          this.data = JSON.parse(JSON.stringify(data));

          this.dlgActive=true;
        }
      },      
      accepted(){

          this.$store.dispatch('newsletter/saveNewsletter', this.data)
          .then(response => {
            if(response.success === true)
            {
                this.$store.dispatch('alertqueue/addSuccess', {'titel':this.$t('COM.SUCCESS.TITEL'),'text':this.$t('NEWSLETTER.ADD_NEWSLETTER.SUCCESS.SAVE')});  
                this.$emit('Success',response.id);
            }
            else
            {
              var text = this.$t(response.text);
              this.$store.dispatch('alertqueue/addWarning', {'titel':this.$t('COM.WARNING.TITEL'),'text':this.$t('NEWSLETTER.ADD_NEWSLETTER.WARNING.SAVE').replace("*1*",text)}); 
            }
            
          }, 
          error =>{
              this.$store.dispatch('alertqueue/addError', {'titel':this.$t('COM.ERROR.TITEL'),'text':this.$t('NEWSLETTER.ADD_NEWSLETTER.ERROR.SAVE').replace("*1*",error)});  
          });

          this.ClearForm();
      },
      canceld(){
        this.ClearForm();
      },
      ClearForm(){ 
        this.data=this.GetEmptyData();
        if(this.recLists.length > 1)
        {
          this.data.rec_list_fk = this.recLists[1].value;
        }
        if(this.templates.length > 1)
        {
          this.data.template_fk = this.templates[1].value;
        }        
      },
      GetEmptyData(){
        return {
          id:0,
          name:"",
          subject:"",
          text:"",
          company_fk:0,
          rec_list_fk:0,
          template_fk:0 
        };
      },
      getTemplateNameById(id){
        let name = "";
        this.templates.forEach(element => {
          if(element.value === id)
          {
            name = element.text;
          }
        });
        return name;
      },
      getRecListNameById(id){
        let name = "";
        this.recLists.forEach(element => {
          if(element.value === id)
          {
            name = element.text;
          }
        });
        return name;
      }
  },
  computed:{
    formValid(){
      return this.data.name.length > 0;
    },
    recLists(){
      var ret = [];
      ret.push({"text": "- - - - -", "value":0});
      
      if(this.$store.state.newsletter.reclists.data != null)
      {
        this.$store.state.newsletter.reclists.data.forEach(element => {
          ret.push({"text": element.name, "value":element.id});
        });
      }
      
      return ret;
    },   
    templates(){
      var ret = [];
      ret.push({"text": "- - - - -", "value":0});

      if(this.$store.state.newsletter.templates.data != null)
      {
        this.$store.state.newsletter.templates.data.forEach(element => {
          ret.push({"text": element.name, "value":element.id});
        });
      }
      return ret;
    }, 

    statusMember(){
      let statmems = [];
      if(this.data && this.IsNotNull(this.data.notes))
      {
       this.data.notes.split("\n").forEach(element => {
        let i = element.indexOf(' - ');
        let splits = [element.slice(0,i), element.slice(i+3)];
        statmems.push({name: splits[0], status: splits[1]});
       }); 
      }
      return statmems;
    },
    wasSent(){
      return this.data && this.data.sent === true;
    }    
  },
  watch:{
  }
};
</script>
<style>
div#promptAddNewsletter > div.vs-dialog{
  max-width: 800px !important;
}

</style>